/*
 * Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
 * Distributed under the TruVideo proprietary license.
 */
import React from 'react';
import PropTypes from 'prop-types';

// Static class names so Tailwind's purge keeps them.
const VARIANT_CLASSES = {
  primary: 'tooltip-primary',
  error: 'tooltip-error',
};
const POSITION_CLASSES = {
  top: 'tooltip-top',
  left: 'tooltip-left',
  bottom: 'tooltip-bottom',
};

/** DaisyUI tooltip around an icon button, styled like the Accounts page action icons. */
const ChecklistIconTooltip = ({ tip, variant = 'primary', position = 'top', children }) => (
  <div
    className={`tooltip ${POSITION_CLASSES[position]} ${VARIANT_CLASSES[variant]} inline-flex before:text-xs before:font-semibold before:whitespace-nowrap`}
    data-tip={tip}
  >
    {children}
  </div>
);

ChecklistIconTooltip.propTypes = {
  tip: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['primary', 'error']),
  position: PropTypes.oneOf(['top', 'left', 'bottom']),
  children: PropTypes.node.isRequired,
};

export default ChecklistIconTooltip;
